import React, { Component } from 'react';

export default function (WrappedComponent, selectData) {
	const CustomTag = selectData == undefined ? `section` : `${selectData}`;

	return class extends React.Component {
		constructor(props) {
			super(props);

			this.state = {
				hovered:false
			}
			this.handleKeyDown = this._handleKeyDown.bind(this);
			this.handleKeyUp = this._handleKeyUp.bind(this);
			this.handlePaste = this._handlePaste.bind(this);
		}

		componentDidMount() {
			if(this.inputElement) {
				this.inputElement.focus();
			}

			document.addEventListener("keydown", this.handleKeyDown);
			document.addEventListener("keyup", this.handleKeyUp);
			document.addEventListener("paste", this.handlePaste);
		}

		componentWillUnmount() {
			document.removeEventListener("keydown", this.handleKeyDown);
			document.removeEventListener("keyup", this.handleKeyUp);
			document.removeEventListener("paste", this.handlePaste);
		}

		_handleKeyDown(event) {
			//if(event.keyCode == 91) this.multiple = true;
		}

		_handleKeyUp(event) {
			if(event.key == "Meta") return;
			if(this.state.hovered) {
				if (this.props.onKeyMouse) this.props.onKeyMouse(event);
			}
		}

		_handlePaste(event) {

			if (!this.state.hovered)return;

			let text;
			var items = (event.clipboardData || event.originalEvent.clipboardData).items;

			var blob = null;
			for(var i = 0; i < items.length; i++) {
				if(items[i].type.indexOf("image") === 0) {
					blob = items[i].getAsFile();
				}
			}

			// load image if there is a pasted image
			if(blob !== null) {
				var reader = new FileReader();
				reader.onload = function(event) {
				};
				reader.readAsDataURL(blob);
			} else {
				text = event.clipboardData.getData('text/plain');

				if(this.props.onMousePaste) this.props.onMousePaste('text',text);
			}
		}

		// inputRef = (element) => {
		// 	this.inputElement = element;
		// 	if (this.props.inputRef !== undefined) this.props.inputRef(element);
		// }

		turnHoverOn () {
			//this.setState({ hovered: true })
			this.setState({ hovered: true })
		}

		turnHoverOff () {
			this.setState({ hovered: false })
			//inputRef={this.inputRef}
		}

		render() {
			return (
				<CustomTag class="in_top" onMouseEnter={() => this.turnHoverOn()} onMouseLeave={() => this.turnHoverOff()}>
					<WrappedComponent {...this.props} />
				</CustomTag>
			);
		}
	};
}